import { render } from "./Alert.vue?vue&type=template&id=7bc2845c"
import script from "./Alert.vue?vue&type=script&lang=ts"
export * from "./Alert.vue?vue&type=script&lang=ts"

import "./Alert.vue?vue&type=style&index=0&id=7bc2845c&lang=stylus"
script.render = render

export default script